import * as React from "react";
const SvgArrowEndLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 22, viewBox: "0 0 11 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.555664 0L10.3334 11L0.555664 22V0Z", fill: "currentColor" }));
export default SvgArrowEndLight;
